import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Popup, Icon, Modal, Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

const {closeQualityAssuranceOrder} = Actions;

const ConfirmationModal = ({order, orderStatusList}) => {
  const [modalStatusSelected, setModalStatusSelected] = useState();
  const dispatch = useDispatch();

  function handleConfirmOrder() {
    dispatch(closeQualityAssuranceOrder(order, modalStatusSelected));
  }

  function getOptions(list, valueField, textField) {
    return list.map((item) => {
      return {'value': item[valueField], 'text': item[textField]};
    });
  }

  function onChangeTemporalValues(value) {
    setModalStatusSelected(value);
  }

  return (
    <Modal size='tiny' className='confirmation-modal'
      trigger={
        <span>
          <Popup
            trigger={
              <span>
                <Icon name='check' className='check circle' size='large' link
                  color='blue' />
              </span>
            }
            content="Cambiar estado"
            position='top center'
            inverted
          />
        </span>
      }
      header={`¿Está seguro que desea cerrar la orden ${order}?`}
      content={
        <div className="m-2">
          <p>Una vez cerrada la orden ya no se puede asignar tareas ni partes</p>
          <div className="inline-container">
            <h4 className="no-margin">Estado</h4>
            <Dropdown
              value={modalStatusSelected}
              options={getOptions(orderStatusList, 'id', 'description')}
              selection
              search
              noResultsMessage='Estado no encontrado'
              onChange={(e, {value}) => onChangeTemporalValues(value)}
                
            />
          </div>
        </div>
      }
      actions={[
        {'key': 'cancel', 'content': 'Cancelar'},
        {'key': 'done', 'content': 'Confirmar', 'positive': true,
          'onClick': () => handleConfirmOrder(order),
          'primary': true,
        },
      ]}
    />
  );
};

export default ConfirmationModal;
